import { apiClient } from "./apiClient";

export interface ContactPayload {
  name: string;
  email: string;
  phone: string;
  message: string;
  inquerytype: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

export const submitContactForm = (payload: ContactPayload) => {
  //alert(JSON.stringify(payload, null, 2));
  console.log(payload);
  return apiClient<{ success: boolean }, ContactPayload>("/api/contact", {
    method: "POST",
    body: payload,
  });
};
